export default __webpack_public_path__ + "static/media/personstory_map_placeholder.b251a160.png";